import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  period: {
    '& > span': {
      visibility: 'hidden',
    },
    '&:hover > span': {
      visibility: 'visible',
    },
    cursor: 'pointer',
    animation: '$fadeIn 0.3s ease-in-out',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.95)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  icon: {
    transform: 'rotate(90deg)',
    marginTop: '-2px',
    transition: 'transform 0.3s ease-in-out',
  },
  iconExpanded: {
    transform: 'rotate(270deg)',
  },
});

export default useStyles;
